import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import { classnames } from 'Utils/classnames';
import PageAccordionRow from 'Components/Rows/PageAccordionRow';
import FAQRowMediaContent from './FAQRowMediaContent';
import EnvironmentManager from 'Utils/environmentManager';
class FAQRow extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  toggleMessage = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  render () {
    const contentClass = classnames({
      'faq-row__content': true,
      'faq-row__content--close': !this.state.isOpen
    });

    const isZendeskActive = EnvironmentManager.getMessageText({
      key: 'is_zendesk_live',
    }) === 'true';

    const isEqualPath = this.props.path === '/yardim/yardim-konulari';

    let iconName = this.state.isOpen ? 'svgMinus' : 'svgPlus';

    //TODO: Animated kısmına bakalım @gürkan
    if (this.props.faqType === 'question') {
      return (<div className="faq-row">
        <div className="faq-row__name" onClick={ this.toggleMessage }>
          <span className="faq-row__subject">{ this.props.question }</span>
          <Icon className="faq-row__expand-icon" iconName={ iconName } />
        </div>
        <div className={ contentClass + ' animated fadeIn' } >
          <div className="faq-row__content__text" dangerouslySetInnerHTML={ { __html: this.props.answer } } />
          { this.props?.videoOrImages?.length > 0 ? <FAQRowMediaContent data={ this.props.videoOrImages } /> : null }
        </div>
      </div>);
    }
    return (
      <PageAccordionRow subject={ this.props.subject } onClick={ () => (isZendeskActive && isEqualPath) ?  window.open('https://yardim.bilyoner.com', '_blank') : this.props.history.push(this.props.path) } />
    );
  }
}

FAQRow.propTypes = {
  history: PropTypes.object,
  subject: PropTypes.string,
  path: PropTypes.string,
  faqType: PropTypes.string,
  question: PropTypes.string,
  answer: PropTypes.string,
  videoOrImages: PropTypes.array,
};

export default withRouter(FAQRow);